module.exports = __webpack_public_path__ + "media/images/main-bg-1152-b6e5f3a031a8f287bf76e8b2199c9138.png";